import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import MessageTypeTable from "./MessageTypeTable";
import MessageTypeDeleteModal from "./MessageTypeDeleteModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const MessageTypePage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewToolManagementMessagesType, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <MessageTypeTable />
          <MessageTypeDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default MessageTypePage;
